// extracted by mini-css-extract-plugin
export default {"locationInfo":"event-multiple-results_locationInfo__YGujn"};